const ttlInSeconds = 20 * 60 * 60;

export const saveData = (name: string, data: any) => {
  const now = new Date();
  localStorage.setItem(`preserve_data_${name}`, JSON.stringify({
    ...data,
    expiry: now.getTime() + ttlInSeconds * 1000
  }))
}

export const removeData = (name: string) => {
  localStorage.removeItem(`preserve_data_${name}`)
}

export const getData = (name: string) => {
  const data = localStorage.getItem(`preserve_data_${name}`)
  const dataParse = data ? JSON.parse(data) : null
  const now = new Date();
  if (data && now.getTime() > dataParse?.expiry) {
    localStorage.removeItem(`preserve_data_${name}`);
    return null;
  }
  return dataParse || null
}
